export default function getNfeFromFileJson(fileJson) {
  return fileJson?.nfeProc?.NFe ?? fileJson?.NFe;
}
